import { useTheme } from '@mui/material';
import tinycolor from 'tinycolor2';

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 255;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */
  return color;
}
export function stringAvatar(name: string) {
  const color = stringToColor(name);
  const theme = useTheme();
  const luminance = tinycolor(color).getLuminance();
  console.log(name);
  let nameToChange = '';
  if (name.split(' ').length > 1) nameToChange = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
  else nameToChange = name[0];
  return {
    sx: {
      border: `1px solid ${theme.colors.gray}`,
      bgcolor: color,
      color: luminance > 0.5 ? '#040D2D' : '#F7F7F7',
    },
    children: `${nameToChange}`,
  };
}
